class NoticeBanner {
    constructor() {
        this.multiMessages = document.querySelector('.messages-multi');

        if (this.multiMessages) {
          this.changeNotice();
        }
    }

    changeNotice() {
        let messages = this.multiMessages.querySelectorAll('.message');
        let count = 1;
        let prev = 0;
        let length = messages.length;

        setInterval(function(){

            if(count >= length) {
                count = 0;
            }
            if(count === 0) {
                prev = (length - 1);
            }
            messages[count].classList.add('-show');
            messages[prev].classList.remove('-show');
            prev = count;
            count += 1;

        }, 5000);
    }
}

module.exports = NoticeBanner;


// WEBPACK FOOTER //
// ./resources/js/classes/notice-banner.js